<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts"></script>

<template>
  <div class="border border-gray-300 rounded-3xl shadow">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped></style>
